import React from "react";
import { formatDate } from "../../../utils/convertDate";
import { FormatMoney } from "../../../utils/formatMoney";

const InvestmentDetails = ({
  cashbackedLoanInvestmentDetails,
  loanDetails,
}) => {
  return (
    <div className="mt-10">
      <div className="font-semibold text-xl border-b-[0.6px] pb-2">
        <h3 className=" uppercase letter-spacing font-w-600 text-gray-800 mt-5">
        Investment Details{" "}
        </h3>
        <hr />
      </div>
      <div className="mt-10 grid grid-cols-2 gap-x-6 gap-y-12 sm:grid-cols-4">
      <div className="sm:col-span-1 mt-1">
          <label
            htmlFor="first-name"
            className="block leading-6 text-gray-900 uppercase font-semibold"
          >
            Date created
          </label>
          <div className="mt-2">
            <p className="  leading-6 text-gray-800">
              {formatDate(cashbackedLoanInvestmentDetails.dateCreated)}
            </p>
          </div>
        </div>
        <div className="sm:col-span-1 mt-1">
          <label
            htmlFor="first-name"
            className="block leading-6 text-gray-900 uppercase font-semibold"
          >
            Investment Status
          </label>
          <div className="mt-2">
            <p className="  leading-6 text-gray-800">
              {loanDetails.investmentStatus}
            </p>
          </div>
        </div>
        <div className="sm:col-span-1 mt-1">
          <label
            htmlFor="first-name"
            className="block leading-6 text-gray-900 uppercase font-semibold"
          >
            Investment currency
          </label>
          <div className="mt-2">
            <p className="  leading-6 text-gray-800">
              {cashbackedLoanInvestmentDetails.investmentCurrency}
            </p>
          </div>
        </div>
        <div className="sm:col-span-1 mt-1">
          <label
            htmlFor="first-name"
            className="block leading-6 text-gray-900 uppercase font-semibold"
          >
            Investment Amount
          </label>
          <div className="mt-2">
            <p className="  leading-6 text-gray-800">
              {FormatMoney(cashbackedLoanInvestmentDetails.amount)}
            </p>
          </div>
        </div>
        <div className="sm:col-span-1 mt-1">
          <label
            htmlFor="first-name"
            className="block leading-6 text-gray-900 uppercase font-semibold"
          >
            Tenor
          </label>
          <div className="mt-2">
            <p className="  leading-6 text-gray-800">
              {cashbackedLoanInvestmentDetails.tenure}
            </p>
          </div>
        </div>
        <div className="sm:col-span-1 mt-1">
          <label
            htmlFor="first-name"
            className="block leading-6 text-gray-900 uppercase font-semibold"
          >
            start date
          </label>
          <div className="mt-2">
            <p className="  leading-6 text-gray-800">
              {formatDate(cashbackedLoanInvestmentDetails.startDate)}
            </p>
          </div>
        </div>
        <div className="sm:col-span-1 mt-1">
          <label
            htmlFor="first-name"
            className="block leading-6 text-gray-900 uppercase font-semibold"
          >
            maturity date
          </label>
          <div className="mt-2">
            <p className="  leading-6 text-gray-800">
              {formatDate(cashbackedLoanInvestmentDetails.endDate)}
            </p>
          </div>
        </div>
        <div className="sm:col-span-1 mt-1">
          <label
            htmlFor="first-name"
            className="block leading-6 text-gray-900 uppercase font-semibold"
          >
            Interest rate
          </label>
          <div className="mt-2">
            <p className="  leading-6 text-gray-800">
              {cashbackedLoanInvestmentDetails.rate} %
            </p>
          </div>
        </div>
        <div className="sm:col-span-1 mt-1">
          <label
            htmlFor="first-name"
            className="block leading-6 text-gray-900 uppercase font-semibold"
          >
            Interest amount
          </label>
          <div className="mt-2">
            <p className="  leading-6 text-gray-800">
              {FormatMoney(cashbackedLoanInvestmentDetails.interestAmount)}
            </p>
          </div>
        </div>
        <div className="sm:col-span-1 mt-1">
          <label
            htmlFor="first-name"
            className="block leading-6 text-gray-900 uppercase font-semibold"
          >
            witholding tax
          </label>
          <div className="mt-2">
            <p className="  leading-6 text-gray-800">
              {FormatMoney(cashbackedLoanInvestmentDetails.whtAmount)}
            </p>
          </div>
        </div>
        <div className="sm:col-span-1 mt-1">
          <label
            htmlFor="first-name"
            className="block leading-6 text-gray-900 uppercase font-semibold"
          >
            Net interest
          </label>
          <div className="mt-2">
            <p className="  leading-6 text-gray-800">
              {FormatMoney(cashbackedLoanInvestmentDetails.netInterest)} 
            </p>
          </div>
        </div>
        <div className="sm:col-span-1 mt-1">
          <label
            htmlFor="first-name"
            className="block leading-6 text-gray-900 uppercase font-semibold"
          >
            Amount at maturity
          </label>
          <div className="mt-2">
            <p className="  leading-6 text-gray-800">
              {FormatMoney(cashbackedLoanInvestmentDetails.totalAmount)}
            </p>
          </div>
        </div>
       
        <div className="sm:col-span-1 mt-1">
          <label
            htmlFor="first-name"
            className="block leading-6 text-gray-900 uppercase font-semibold"
          >
            Investment amount locked
          </label>
          <div className="mt-2">
            <p className="  leading-6 text-gray-800">
              {cashbackedLoanInvestmentDetails.isUnlocked ? "No" : "Yes"}
            </p>
          </div>
        </div>
        <div className="sm:col-span-1 mt-1">
          <label
            htmlFor="first-name"
            className="block leading-6 text-gray-900 uppercase font-semibold"
          >
            Investment blocked
          </label>
          <div className="mt-2">
            <p className="  leading-6 text-gray-800">
              {cashbackedLoanInvestmentDetails.isBlocked ? "Yes" : "No"}
            </p>
          </div>
        </div>
        <div className="sm:col-span-1 mt-1">
          <label
            htmlFor="first-name"
            className="block leading-6 text-gray-900 uppercase font-semibold"
          >
            Source account number
          </label>
          <div className="mt-2">
            <p className="  leading-6 text-gray-800">
              {cashbackedLoanInvestmentDetails.sourceAccountNumber}
            </p>
          </div>
        </div>
       
      </div>
    </div>
  );
};

export default InvestmentDetails;
